export default ((): CollectionState => ({
  itemsByPages: [],
  excludedItems: [],
}))();
